import { DocumentNode } from 'graphql';
import React, { cloneElement, useState } from 'react';
import { getValuesFromTask } from './task-helpers';
import {
  Actions,
  AppArea,
  MostQuerySuggestedTask,
  Subjects,
} from 'src/graphql/generated/graphql';
import { Schedule } from '@otp/icons';
import { ScheduledJobForm } from '../list/scheduled-jobs/form/scheduled-job';
import { Can } from 'src/utils/can';

type RunScheduleProps = {
  selectedTask?: {
    task: MostQuerySuggestedTask;
    storeId: string;
  };
  refetchQueries?: DocumentNode[];
  children?: React.ReactElement;

  title?:
    | string
    | (string & React.ReactPortal)
    | (string &
        React.ReactElement<any, string | React.JSXElementConstructor<any>>)
    | (string & Iterable<React.ReactNode>);
  hiddenFields?: Array<'callout' | 'storeIds' | 'devices' | 'recurring'>;
  disabledFields?: {
    storeIds?: boolean;
    action?: boolean;
    devices?: boolean;
    date?: boolean;
    time?: boolean;
    recurring?: boolean;
  };
  disabled?: boolean;
};

export const RunSchedule = ({
  selectedTask,
  refetchQueries,
  children,
  hiddenFields,
  title,
  disabledFields,
  disabled,
}: RunScheduleProps) => {
  const [showDialog, setShowDialog] = useState(false);
  const handleClick = async () => {
    setShowDialog(!disabled);
  };

  const renderChildren = (children: React.ReactElement) =>
    cloneElement(children, { onClick: handleClick });

  const toggleShowDialog = () => {
    setShowDialog(!showDialog);
  };

  let renderedChildren = <Schedule onClick={handleClick} />;

  if (children) {
    renderedChildren = renderChildren(children);
  }

  return (
    <Can I={Actions.Write} a={Subjects.Jobs} appArea={AppArea.Most}>
      {showDialog && (
        <ScheduledJobForm
          title={title}
          defaultValues={selectedTask && getValuesFromTask(selectedTask)}
          refetchQueries={refetchQueries}
          onClose={toggleShowDialog}
          onFinish={toggleShowDialog}
          hiddenFields={hiddenFields}
          disabledFields={disabledFields}
        />
      )}
      {renderedChildren}
    </Can>
  );
};
